import { render, staticRenderFns } from "./TurboFeatures.vue?vue&type=template&id=4716dee7&scoped=true&"
import script from "./TurboFeatures.vue?vue&type=script&lang=js&"
export * from "./TurboFeatures.vue?vue&type=script&lang=js&"
import style0 from "./TurboFeatures.vue?vue&type=style&index=0&id=4716dee7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4716dee7",
  null
  
)

export default component.exports